var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.22223C11.0019 6.95549 10.8306 7.67883 10.5 8.33334C10.108 9.11764 9.5054 9.77732 8.75968 10.2385C8.01396 10.6997 7.15457 10.9441 6.27777 10.9444C5.54451 10.9464 4.82117 10.775 4.16666 10.4444L1 11.5L2.05555 8.33334C1.72496 7.67883 1.55364 6.95549 1.55555 6.22223C1.55589 5.34543 1.80034 4.48604 2.26151 3.74032C2.72268 2.9946 3.38236 2.392 4.16666 2.00002C4.82117 1.66942 5.54451 1.4981 6.27777 1.50002H6.55555C7.71352 1.5639 8.80723 2.05266 9.62729 2.87271C10.4473 3.69277 10.9361 4.78648 11 5.94445V6.22223Z",
    stroke: "#8BD8BD",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9f3070dfe870e7be83c8aa6b2c3d4132.svg";
export { ForwardRef as ReactComponent };